<p-panel styleClass="snapshot-panel" [toggleable]="true" [collapsed]="true">

  <ng-template #header>
    <div class="snapshot-header">

      @if (profilePicSrc) {
      <img class="patient-headshot" [src]="profilePicSrc" id="profile" />
      } @else {
      <span class="patient-headshot"></span>
      }
      <!-- <span *ngIf="!profilePicSrc; else showProfilePic" class="patient-headshot"></span>
      <ng-template #showProfilePic>
        <img class="patient-headshot" [src]="profilePicSrc" id="profile" />
      </ng-template> -->
      <div>
        <h1>{{ patient.getLastFirstMiddleName() }}</h1>
        <span>MRN: {{ patient.mrn }}</span>
      </div>
    </div>
  </ng-template>

  <!-- Use #icon: https://github.com/primefaces/primeng/issues/17041 -->
  <ng-template #icon pTemplate="icons">
    <p-button icon="pi pi-cog" rounded text (click)="menu.toggle($event)" />
    <p-menu #menu id="config_menu" [model]="menuItems" [popup]="true" />
  </ng-template>

  <div class="snapshot-content">
    <div class="snapshot-content-section">
      <p>Date of Birth: {{ patient.getDOBString().split('/').slice(0, 2).join('/') }}</p>
      <p>Age: {{ patient.getAge() }}</p>
      <p>Height: {{ patient.getHeightString() }}</p>
      <p>Weight: {{ patient.getWeight() }} kgs</p>
      <p>BMI: {{ patient.getBMI() }}</p>
    </div>
    <div class="snapshot-content-section">
      <p>Type: {{ patient.getType() }} </p>
      <p>Room #: {{ patient.getRoomNumber() }} </p>
      <p>Location: {{ patient.getLocation() }} </p>
      <p>Sex: {{ patient.getSex() }}</p>
    </div>
    <div class="snapshot-content-section">
      <p>Code Status: {{ patient.getCodeStatus() }}</p>
      <p>Isolation: {{ patient.getIsolation() }}</p>
      <p>
        Interdisciplinary Team Members:
        @if (patient.interdisciplinaryTeam.length === 0) {
        <span>None</span>
        }
      </p>
      <ul class="team-members">
        @for (member of patient.interdisciplinaryTeam; track $index) {
        <li>
          <span>{{ member.specialization }}: {{ member.name }}</span>
          @if (member.title && member.title !== '') {
          <span> ({{ member.title }})</span>
          }
        </li>
        }
      </ul>
      <p>Allergies:
        @if (patient.allergies.length === 0) {
        <span>None</span>
        }
      </p>
      <ul class="allergies">
        @for (allergy of patient.allergies; track $index) {
        <li>
          <span>{{ allergy.name }}</span>
          @if (allergy.altName && allergy.altName !== '') {
          <span> ({{ allergy.altName }})</span>
          }
        </li>
        }
      </ul>
      <p>
        Current Active Medical Problems:
        @if (patient.activeMedicalProblems.length === 0) {
        <span>None</span>
        }
      </p>
      <ul class="active-medical-problems">
        @for (medProb of patient.activeMedicalProblems; track $index) {
        <li>
          <span>{{ medProb.name }}</span>
          @if (medProb.altName && medProb.altName !== '') {
          <span> ({{ medProb.altName }})</span>
          }
        </li>
        }
      </ul>
    </div>
  </div>
</p-panel>